import { addTableHeader, breakWord, drawBody } from "../InvoiceGeneratorUtils";
import { IGeneratePDF_SIMPEL } from "../generateInvoice.type";

const PDF_SIMPEL = (data: IGeneratePDF_SIMPEL) => {
  const header = [
    {
      title: "NO",
      style: {
        width: 10,
      },
    },
    {
      title: "NAMA BARANG",
      style: {
        width: 100,
      },
    },
    {
      title: "SAT",
      style: {
        width: 30,
      },
    },
    {
      title: "HARGA",
      style: {
        width: 30,
      },
    },
    {
      title: "QTY",
      style: {
        width: 12,
      },
    },
    {
      title: "TOTAL",
    },
  ];

  // Data Table
  const dataTable: any[] = [];
  data.invoice.forEach((item, index) => {
    let temp: any[] = [];
    temp.push(index + 1); // No
    temp.push(item.name); // Nama Barang
    temp.push(item.unitType); // Satuan
    temp.push(item.price); // Harga
    temp.push(item.qty); // Qty
    temp.push(item.total); // Total
    dataTable.push(temp);
    temp = [];
  });

  const print = (doc: any) => {
    // Variable
    const docWidth = doc.internal.pageSize.width;
    const docHeight = doc.internal.pageSize.height;
    const currentHeight = 15;
    const colorBlack = "#000000";
    const colorGray = "#4d4e53";
    const fieldTextSize = 10;
    const subLineHeight = 4;
    const tdWidth = (doc.getPageWidth() - 20) / header.length;
    const headerTextSize = 20;
    const labelTextSize = 12;
    const lineHeight = 6;

    const pdfConfig = {
      docWidth,
      docHeight,
      currentHeight,
      colorBlack,
      colorGray,
      fieldTextSize,
      subLineHeight,
      header,
      dataTable,
      tdWidth,
      headerTextSize,
      labelTextSize,
      lineHeight,
    };

    // Header Invoice
    doc.setFontSize(12);
    pdfConfig.currentHeight += breakWord(
      data?.customerName || "",
      doc,
      pdfConfig.currentHeight - 4,
      pdfConfig.docWidth - 12
    );
    pdfConfig.currentHeight += 3;
    doc.setFontSize(pdfConfig.fieldTextSize);
    doc.setFontSize(17);
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight + 2,
      `# ${data.customerName}`,
      "right"
    );
    doc.setFontSize(12);
    doc.setTextColor(pdfConfig.colorBlack);
    doc.text(10, pdfConfig.currentHeight + 2, `TANGGAL : ${data.date} `);
    doc.setFontSize(pdfConfig.fieldTextSize);
    doc.setTextColor(pdfConfig.colorGray);
    pdfConfig.currentHeight += pdfConfig.subLineHeight;
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );
    pdfConfig.currentHeight += 1;

    // Table Header
    addTableHeader({ doc: doc, config: pdfConfig });
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );

    // Table Body
    doc.setFontSize(pdfConfig.fieldTextSize + 1);
    drawBody({ doc: doc, config: pdfConfig });
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );
    pdfConfig.currentHeight += 55;

    // Footer Invoice Right Side
    // pdfConfig.currentHeight = pdfConfig.currentHeight - 44;
    // doc.setFontSize(10);
    // doc.text(
    //   pdfConfig.docWidth / 1.2,
    //   pdfConfig.currentHeight,
    //   "TAX:",
    //   "right"
    // );
    // doc.text(
    //   pdfConfig.docWidth - 10,
    //   pdfConfig.currentHeight,
    //   `${Math.round(data?.tax || 0)}`,
    //   "right"
    // );
    // pdfConfig.currentHeight += 6;
    // doc.text(
    //   pdfConfig.docWidth / 1.2,
    //   pdfConfig.currentHeight,
    //   "PPH:",
    //   "right"
    // );
    // doc.text(
    //   pdfConfig.docWidth - 10,
    //   pdfConfig.currentHeight,
    //   `${ToMoneyFormat(Math.round(data?.pph || 0))}`,
    //   "right"
    // );
    // pdfConfig.currentHeight += 6;
    doc.setFontSize(14);
    doc.text(
      pdfConfig.docWidth / 1.2,
      pdfConfig.currentHeight,
      "TOTAL:",
      "right"
    );
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight,
      `${data.total}`,
      "right"
    );
    doc.setFontSize(11);
    pdfConfig.currentHeight += 6;
    doc.text(
      pdfConfig.docWidth - 8,
      pdfConfig.currentHeight,
      "TOTAL PACKING, NOTA, & TGL PACKING :",
      "right"
    );
    pdfConfig.currentHeight += 6;
    doc.text(
      pdfConfig.docWidth - 8,
      pdfConfig.currentHeight,
      "......................................",
      "right"
    );
  };

  return { print };
};

export { PDF_SIMPEL };
